import { HttpClientConfig, HttpClient } from "../HttpClient";

export const API_URL = `${process.env.REACT_APP_MAILS_URL}/v1`;

export class MailsLoader {
  static post<T = void>(config: HttpClientConfig) {
    return new HttpClient<T>({ baseURL: API_URL, ...config }).post();
  }

  static get<T = void>(config: HttpClientConfig) {
    return new HttpClient<T>({ baseURL: API_URL, ...config }).get();
  }
}
